import { PaymentSuccess, usePaymentData } from '@p2p/entities/payment';

export const PaymentSuccessPage = () => {
  const { order } = usePaymentData();

  return <PaymentSuccess order={order} />;
};
